const marka = { t: 'Marka', name: 'marka', hint: { url: '/make/heavy', cache: 'heavy-make', exact: true }}
export default marka